<template>
  <div>
    <router-link :to="{ name: 'Beta-Agent' }" class="btn-primary-sm text-xs inline-block">Open the agent</router-link>
  </div>
</template>

<script>
export default {
  name: 'OverviewETLAgent',
  methods: {
    openFile(s3Key) {
      this.$router.push({ name: 'Beta-Agent', query: s3Key ? { file: s3Key } : {} });
    },
  },
};
</script>
